import { z } from 'zod';

/**
 * Server Validation Schemas
 */

// IP address regex
const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const serverSchema = z.object({
  serverName: z
    .string()
    .min(1, 'Server name is required')
    .max(100, 'Server name must be less than 100 characters'),
  ipAddress: z
    .string()
    .min(1, 'IP address is required')
    .regex(ipRegex, 'Please enter a valid IP address'),
  username: z
    .string()
    .min(1, 'Username is required')
    .max(100, 'Username must be less than 100 characters'),
  password: z
    .string()
    .min(1, 'Password is required')
    .max(200, 'Password must be less than 200 characters'),
  domain: z
    .string()
    .min(1, 'Domain is required')
    .max(200, 'Domain must be less than 200 characters'),
  serverRoles: z
    .string()
    .max(500, 'Server roles must be less than 500 characters')
    .optional()
    .or(z.literal('')),
  notes: z
    .string()
    .max(1000, 'Notes must be less than 1000 characters')
    .optional()
    .or(z.literal('')),
});

export const serverInfoSchema = z.object({
  hasServers: z.boolean().default(false),
  serverLocation: z
    .enum(['', 'Head Office', 'Cloud Based', 'Per Branch'])
    .default(''),
});

// Device schema for onboarding
export const deviceSchema = z.object({
  deviceName: z
    .string()
    .min(1, 'Device name is required')
    .max(100, 'Device name must be less than 100 characters'),
  ipAddress: z
    .string()
    .min(1, 'IP address is required')
    .regex(ipRegex, 'Please enter a valid IP address'),
  deviceUsername: z
    .string()
    .max(100, 'Username must be less than 100 characters')
    .optional()
    .or(z.literal('')),
  devicePassword: z
    .string()
    .max(200, 'Password must be less than 200 characters')
    .optional()
    .or(z.literal('')),
  agentInstalled: z.boolean().default(false),
  notes: z
    .string()
    .max(1000, 'Notes must be less than 1000 characters')
    .optional()
    .or(z.literal('')),
});

// User onboarding schema
export const userOnboardingSchema = z.object({
  userName: z
    .string()
    .min(1, 'User name is required')
    .max(100, 'User name must be less than 100 characters'),
  userEmail: z
    .string()
    .email('Please enter a valid email address')
    .optional()
    .or(z.literal('')),
  agentInstalled: z.boolean().default(false),
  managedAVInstalled: z.boolean().default(false),
  mailSetup: z.boolean().default(false),
  oneDriveSetup: z.boolean().default(false),
  cyberFoxInstalled: z.enum(['Yes', 'No']).default('No'),
  acronisSetup: z.enum(['Yes', 'No']).default('No'),
  notes: z
    .string()
    .max(1000, 'Notes must be less than 1000 characters')
    .optional()
    .or(z.literal('')),
});

export default serverSchema;

